/** Temporary screen for stages that have not been implemented yet. */
export function Planned() {
    return <p className="p-4 text-text-muted">Раздел появится в следующих шагах.</p>;
}
